import { UseControllerProps } from 'react-hook-form';

/** Represents the controller props for a React Hook Form based form component. */
export const hookFormControllerProps: readonly (keyof UseControllerProps)[] = [
  'control',
  'defaultValue',
  'name',
  'rules',
  'shouldUnregister',
];
